"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const alpinejs_1 = __importDefault(require("alpinejs"));
const swiper_1 = __importDefault(require("swiper"));
const modules_1 = require("swiper/modules");
swiper_1.default.use([modules_1.Pagination, modules_1.Navigation]);
// import Swiper styles
require("swiper/css");
alpinejs_1.default.data("loader", () => {
    return {
        globalLoader: false,
        setLoading(status) {
            this.globalLoader = status;
        },
    };
});
alpinejs_1.default.data("contactForm_WorkWithUs", () => {
    return {
        data: {
            token: "",
            titolo: "",
            type: "Candidatura",
            candidatura: "",
            nome: "",
            cognome: "",
            via: "",
            numero_civico: "",
            CAP: "",
            localita: "",
            provincia: "",
            telefono: "",
            curr_email: "",
            cv: null,
            privacy: false,
        },
        validationErrors: {
            token: false,
            type: false,
            candidatura: false,
            titolo: false,
            nome: false,
            cognome: false,
            via: false,
            numero_civico: false,
            CAP: false,
            localita: false,
            provincia: false,
            telefono: false,
            curr_email: false,
            cv: false,
            privacy: false,
        },
        controlData: {
            token: { required: false },
            type: { required: true },
            candidatura: { required: false },
            titolo: { required: true },
            nome: { required: true },
            cognome: { required: true },
            via: { required: true },
            numero_civico: { required: true },
            CAP: { required: true },
            localita: { required: true },
            provincia: { required: true },
            telefono: { required: true },
            curr_email: { required: true },
            cv: { required: true },
            privacy: { required: true },
        },
        openDatiPersonali: true,
        openFormazioneCompetenze: false,
        openDettagliCandidatura: false,
        sent: false,
        result: false,
        loading: false,
        send: "",
        submit(token) {
            var _a;
            this.data.token = token;
            for (let k in this.data) {
                if (typeof this.data[k] === "boolean") {
                    if (this.controlData[k].required === true) {
                        if (!this.data[k]) {
                            this.validationErrors[k] = true;
                        }
                        else {
                            this.validationErrors[k] = false;
                        }
                    }
                }
                else {
                    if ((this.data[k] === "" || this.data[k] === null) &&
                        this.controlData[k].required === true) {
                        this.validationErrors[k] = true;
                    }
                    else {
                        this.validationErrors[k] = false;
                    }
                }
            }
            const check = Object.values(this.validationErrors).every((i) => i === false);
            if (check) {
                if (this.sent || this.loading)
                    return;
                this.$dispatch("loader:open");
                if (window.dataLayer)
                    window.dataLayer.push({
                        event: "generate_lead",
                        form_type: "work-with-us",
                    });
                //sending form
                this.$dispatch("loader:open");
                const formData = new FormData();
                formData.append("action", "form_submit");
                for (let k in this.data) {
                    if (typeof this.data[k] === "boolean")
                        formData.append(k, this.data[k] ? "1" : "0");
                    else
                        formData.append(k, this.data[k]);
                }
                if (this.sent || this.loading)
                    return;
                this.loading = true;
                fetch("/wp-admin/admin-ajax.php", {
                    method: "POST",
                    credentials: "same-origin",
                    body: formData,
                })
                    .then(() => {
                    var _a;
                    this.result = true;
                    this.sent = true;
                    this.loading = false;
                    this.$dispatch("loader:close");
                    (_a = document.getElementById("form")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                })
                    .catch(() => {
                    this.result = false;
                    this.sent = false;
                });
            }
            else {
                console.log("err", check);
                this.loading = false;
                this.$dispatch("loader:close");
                this.sent = false;
                this.openDatiPersonali = true;
                this.openFormazioneCompetenze = true;
                this.openDettagliCandidatura = true;
                (_a = document.getElementById("form")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
            }
        },
    };
});
alpinejs_1.default.data("contactForm_WorkWithUsDE", () => {
    return {
        data: {
            token: "",
            titolo: "",
            type: "Candidatura_DE",
            candidatura: "",
            nome: "",
            cognome: "",
            sesso: "",
            telefono: "",
            curr_email: "",
            lettera: null,
            cv: null,
            privacy: false,
        },
        validationErrors: {
            token: false,
            type: false,
            candidatura: false,
            titolo: false,
            nome: false,
            cognome: false,
            sesso: false,
            telefono: false,
            curr_email: false,
            lettera: false,
            cv: false,
            privacy: false,
        },
        controlData: {
            token: { required: false },
            type: { required: true },
            candidatura: { required: false },
            titolo: { required: true },
            nome: { required: true },
            cognome: { required: true },
            sesso: { required: true },
            telefono: { required: true },
            curr_email: { required: true },
            lettera: { required: true },
            cv: { required: true },
            privacy: { required: true },
        },
        openDatiPersonali: true,
        openFormazioneCompetenze: false,
        openDettagliCandidatura: false,
        sent: false,
        result: false,
        loading: false,
        send: "",
        submit(token) {
            var _a;
            this.data.token = token;
            for (let k in this.data) {
                if (typeof this.data[k] === "boolean") {
                    if (this.controlData[k].required === true) {
                        if (!this.data[k]) {
                            this.validationErrors[k] = true;
                        }
                        else {
                            this.validationErrors[k] = false;
                        }
                    }
                }
                else {
                    if ((this.data[k] === "" || this.data[k] === null) &&
                        this.controlData[k].required === true) {
                        this.validationErrors[k] = true;
                    }
                    else {
                        this.validationErrors[k] = false;
                    }
                }
            }
            if (Object.values(this.validationErrors).every((i) => i === false)) {
                if (this.sent || this.loading)
                    return;
                this.$dispatch("loader:open");
                if (window.dataLayer)
                    window.dataLayer.push({
                        event: "generate_lead",
                        form_type: "work-with-us",
                    });
                //sending form
                this.$dispatch("loader:open");
                const formData = new FormData();
                formData.append("action", "form_submit");
                for (let k in this.data) {
                    if (typeof this.data[k] === "boolean")
                        formData.append(k, this.data[k] ? "1" : "0");
                    else
                        formData.append(k, this.data[k]);
                }
                if (this.sent || this.loading)
                    return;
                this.loading = true;
                fetch("/wp-admin/admin-ajax.php", {
                    method: "POST",
                    credentials: "same-origin",
                    body: formData,
                })
                    .then(() => {
                    var _a;
                    this.result = true;
                    this.sent = true;
                    this.loading = false;
                    this.$dispatch("loader:close");
                    (_a = document.getElementById("form")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                })
                    .catch(() => {
                    this.result = false;
                    this.sent = false;
                });
            }
            else {
                this.loading = false;
                this.$dispatch("loader:close");
                this.sent = false;
                this.openDatiPersonali = true;
                this.openFormazioneCompetenze = true;
                this.openDettagliCandidatura = true;
                (_a = document.getElementById("form")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
            }
        },
    };
});
alpinejs_1.default.data("contactForm_WorkWithUsRU", () => {
    return {
        data: {
            token: "",
            type: "Candidatura",
            candidatura: "",
            nome: "",
            cognome: "",
            sesso: "",
            telefono: "",
            curr_email: "",
            lettera: null,
            cv: null,
            privacy: false,
        },
        validationErrors: {
            token: false,
            type: false,
            candidatura: false,
            nome: false,
            cognome: false,
            sesso: false,
            telefono: false,
            curr_email: false,
            lettera: false,
            cv: false,
            privacy: false,
        },
        controlData: {
            token: { required: false },
            type: { required: true },
            candidatura: { required: false },
            nome: { required: true },
            cognome: { required: true },
            sesso: { required: true },
            telefono: { required: true },
            curr_email: { required: true },
            lettera: { required: true },
            cv: { required: true },
            privacy: { required: true },
        },
        openDatiPersonali: true,
        openFormazioneCompetenze: false,
        openDettagliCandidatura: false,
        sent: false,
        result: false,
        loading: false,
        send: "",
        submit(token) {
            var _a;
            this.data.token = token;
            for (let k in this.data) {
                if (typeof this.data[k] === "boolean") {
                    if (this.controlData[k].required === true) {
                        if (!this.data[k]) {
                            this.validationErrors[k] = true;
                        }
                        else {
                            this.validationErrors[k] = false;
                        }
                    }
                }
                else {
                    if ((this.data[k] === "" || this.data[k] === null) &&
                        this.controlData[k].required === true) {
                        this.validationErrors[k] = true;
                    }
                    else {
                        this.validationErrors[k] = false;
                    }
                }
            }
            if (Object.values(this.validationErrors).every((i) => i === false)) {
                if (this.sent || this.loading)
                    return;
                this.$dispatch("loader:open");
                if (window.dataLayer)
                    window.dataLayer.push({
                        event: "generate_lead",
                        form_type: "work-with-us",
                    });
                //sending form
                this.$dispatch("loader:open");
                const formData = new FormData();
                formData.append("action", "form_submit");
                for (let k in this.data) {
                    if (typeof this.data[k] === "boolean")
                        formData.append(k, this.data[k] ? "1" : "0");
                    else
                        formData.append(k, this.data[k]);
                }
                if (this.sent || this.loading)
                    return;
                this.loading = true;
                fetch("/wp-admin/admin-ajax.php", {
                    method: "POST",
                    credentials: "same-origin",
                    body: formData,
                })
                    .then(() => {
                    var _a;
                    this.result = true;
                    this.sent = true;
                    this.loading = false;
                    this.$dispatch("loader:close");
                    (_a = document.getElementById("form")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                })
                    .catch(() => {
                    this.result = false;
                    this.sent = false;
                });
            }
            else {
                this.loading = false;
                this.$dispatch("loader:close");
                this.sent = false;
                this.openDatiPersonali = true;
                this.openFormazioneCompetenze = true;
                this.openDettagliCandidatura = true;
                (_a = document.getElementById("form")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
            }
        },
    };
});
alpinejs_1.default.data("contactForm_General", () => {
    return {
        data: {
            token: "",
            type: "Richiesta generica",
            nome: "",
            cognome: "",
            //provincia: "",
            email: "",
            phone: "",
            scadenza: "",
            lotto: "",
            attachment: null,
            messaggio: "",
            privacy: false,
        },
        validationErrors: {
            token: false,
            type: false,
            nome: false,
            cognome: false,
            //provincia: false,
            email: false,
            phone: false,
            scadenza: false,
            lotto: false,
            attachment: false,
            messaggio: false,
            privacy: false,
        },
        controlData: {
            token: { required: false },
            type: { required: true },
            nome: { required: true },
            cognome: { required: true },
            //provincia: { required: true },
            email: { required: true },
            phone: { required: true },
            scadenza: { required: false },
            lotto: { required: false },
            attachment: { required: false },
            messaggio: { required: true },
            privacy: { required: true },
        },
        sent: false,
        result: false,
        loading: false,
        submit(token) {
            this.data.token = token;
            for (let k in this.data) {
                if (typeof this.data[k] === "boolean") {
                    if (k == "type" && this.data[k] == "Segnalazione su prodotti") {
                        this.controlData["scadenza"].required = true;
                        this.controlData["lotto"].required = true;
                    }
                    else {
                        this.controlData["scadenza"].required = false;
                        this.controlData["lotto"].required = false;
                    }
                    if (this.controlData[k].required === true) {
                        if (!this.data[k]) {
                            this.validationErrors[k] = true;
                        }
                        else {
                            this.validationErrors[k] = false;
                        }
                    }
                }
                else {
                    if ((this.data[k] === "" || this.data[k] === null) &&
                        this.controlData[k].required === true) {
                        this.validationErrors[k] = true;
                    }
                    else {
                        this.validationErrors[k] = false;
                    }
                }
            }
            console.log(this.validationErrors);
            if (Object.values(this.validationErrors).every((i) => i === false)) {
                this.$dispatch("loader:open");
                const formData = new FormData();
                formData.append("action", "form_submit");
                for (let k in this.data) {
                    if (typeof this.data[k] === "boolean")
                        formData.append(k, this.data[k] ? "1" : "0");
                    else
                        formData.append(k, this.data[k]);
                }
                fetch("/wp-admin/admin-ajax.php", {
                    method: "POST",
                    credentials: "same-origin",
                    body: formData,
                })
                    .then(() => {
                    this.result = true;
                    this.sent = true;
                    this.loading = false;
                    this.$dispatch("loader:close");
                    if (window.dataLayer)
                        window.dataLayer.push({
                            event: "generate_lead",
                            form_type: "contact-us",
                        });
                })
                    .catch((e) => {
                    console.log(e);
                    this.result = false;
                    this.sent = false;
                    this.error = true;
                });
            }
            else {
                window.scrollTo(0, 0);
                console.log("err");
                this.loading = false;
                this.sent = false;
            }
        },
    };
});
alpinejs_1.default.data("contactForm_recipe", (slug) => {
    return {
        data: {
            token: "",
            nome: "",
            cognome: "",
            email: "",
            telefono: "",
            messaggio: "",
            privacy: false,
            product: slug,
        },
        validationErrors: {
            token: false,
            nome: false,
            cognome: false,
            email: false,
            telefono: false,
            messaggio: false,
            privacy: false,
            product: false,
        },
        controlData: {
            token: { required: false },
            nome: { required: true },
            cognome: { required: true },
            email: { required: true },
            telefono: { required: false },
            messaggio: { required: true },
            privacy: { required: true },
            product: { required: false },
        },
        sent: false,
        result: false,
        loading: false,
        send: "",
        submit(token) {
            this.data.token = token;
            for (let k in this.data) {
                if (typeof this.data[k] === "boolean") {
                    if (this.controlData[k].required === true) {
                        if (!this.data[k]) {
                            this.validationErrors[k] = true;
                        }
                        else {
                            this.validationErrors[k] = false;
                        }
                    }
                }
                else {
                    if ((this.data[k] === "" || this.data[k] === null) &&
                        this.controlData[k].required === true) {
                        this.validationErrors[k] = true;
                    }
                    else {
                        this.validationErrors[k] = false;
                    }
                }
                if (Object.values(this.validationErrors).every((i) => i === false)) {
                    this.$dispatch("loader:open");
                    const formData = new FormData();
                    formData.append("action", "form_submit");
                    for (let k in this.data) {
                        if (typeof this.data[k] === "boolean")
                            formData.append(k, this.data[k] ? "1" : "0");
                        else
                            formData.append(k, this.data[k]);
                    }
                    if (this.sent || this.loading)
                        return;
                    this.loading = true;
                    fetch("/wp-admin/admin-ajax.php", {
                        method: "POST",
                        credentials: "same-origin",
                        body: formData,
                    })
                        .then(() => {
                        this.result = true;
                        this.sent = true;
                        this.loading = false;
                        this.$dispatch("loader:close");
                        if (window.dataLayer)
                            window.dataLayer.push({
                                event: "generate_lead",
                                form_type: "recipe",
                                item_name: this.data.product,
                            });
                    })
                        .catch((e) => {
                        console.log(e);
                        this.result = false;
                        this.sent = false;
                        this.error = true;
                    });
                }
                else {
                    window.scrollTo(0, 0);
                    console.log("err");
                    this.loading = false;
                    this.sent = false;
                }
            }
        },
    };
});
alpinejs_1.default.data("archive_recipes", () => {
    return {
        data: {
            totalPages: 0,
            page: 1,
            limit: 24,
            pagination: true,
            type: "",
            taste: "",
            cerca: "",
            reset_button: false,
        },
        populate() {
            this.data.reset_button = true;
            console.log("this.data.reset_button");
            console.log(this.data.reset_button);
            this.$dispatch("loader:open");
            const formData = new FormData();
            formData.append("action", "archive_recipes");
            formData.append("page", this.data.page);
            formData.append("limit", this.data.limit);
            formData.append("taste", this.data.taste);
            formData.append("type", this.data.type);
            formData.append("cerca", this.data.cerca);
            fetch("/wp-admin/admin-ajax.php", {
                method: "POST",
                credentials: "same-origin",
                body: formData,
            }).then((res) => {
                res.json().then((data) => {
                    this.data.totalPages = data.total_pages;
                    const html = [];
                    for (const recipe of data.posts) {
                        html.push("" +
                            '<div class="ricette bg-beige box-shadow flex lg:block">' +
                            '<a href="' +
                            recipe.permalink +
                            '">' +
                            '<figure class="lg:w-full w-[120px] lg:h-[266px] m-0">' +
                            '<img class="lg:w-full w-[120px] lg:h-[266px] h-[120px] object-cover object-center" src="' +
                            recipe.thumbnail +
                            '">' +
                            "</figure>" +
                            "</a>" +
                            '<div class="lg:min-h-[195px] lg:pt-[35px] lg:pb-[40px] lg:px-[20px] p-[16px]">' +
                            '<h2 class="mt-0 lg:mb-[20px] mt-0 lg:text-center text-left !leading-percent-100"><a class="ricetta_titolo text-blue lg:!text-xl xm:text-xsm text-xxs font-black lg:tracking-[4px] tracking-[3px] font-title no-underline !leading-percent-100" data-text="' +
                            recipe.title +
                            '" href="' +
                            recipe.permalink +
                            '">' +
                            recipe.title +
                            "</a></h2>" +
                            '<p class="mt-0 text-center text-grey font-body text-xlg lg:block hidden">' +
                            recipe.excerpt +
                            "</p>" +
                            "</div>" +
                            "</div>" +
                            "</div>" +
                            "</div>");
                    }
                    document.getElementById("container-ricette").innerHTML = html.join("\n");
                    this.$dispatch("loader:close");
                    console.log("esegui handleRicetteTextTruncation");
                    handleRicetteTextTruncation();
                });
            });
        },
        reset() {
            this.data.type = "";
            this.data.taste = "";
            this.data.cerca = "";
            this.populate();
            console.log("this.data.reset_button + reset");
            this.data.reset_button = false;
        },
    };
});
alpinejs_1.default.data("archive_posts", () => {
    return {
        data: {
            page: 1,
            limit: 3,
            totalPages: 0,
            pagination: true,
        },
        populate() {
            this.$dispatch("loader:open");
            const formData = new FormData();
            formData.append("action", "archive_posts");
            formData.append("page", this.data.page);
            formData.append("limit", this.data.limit);
            fetch("/wp-admin/admin-ajax.php", {
                method: "POST",
                credentials: "same-origin",
                body: formData,
            }).then((res) => {
                res.json().then((data) => {
                    console.log(formData);
                    this.data.totalPages = data.total_pages;
                    console.log(this.data.totalPages);
                    console.log(this.data.page);
                    console.log(this.data.limit);
                    console.log(data);
                    const html = [];
                    for (const recipe of data.posts) {
                        html.push("" +
                            '<div class="ricette bg-beige box-shadow flex lg:block">' +
                            '<a href="' +
                            recipe.permalink +
                            '">' +
                            '<figure class="lg:w-full w-[120px] lg:h-[266px] m-0">' +
                            '<img class="lg:w-full w-[120px] lg:h-[266px] h-[120px] object-cover object-center" src="' +
                            recipe.thumbnail +
                            '">' +
                            "</figure>" +
                            "</a>" +
                            '<div class="lg:min-h-[195px] lg:pt-[35px] lg:pb-[40px] lg:px-[20px] p-[16px]">' +
                            '<h2 class="mt-0 lg:mb-[20px] mt-0 lg:text-center text-left !leading-percent-100"><a class="ricetta_titolo text-blue lg:!text-xl xm:text-xsm text-xxs font-black lg:tracking-[4px] tracking-[3px] font-title no-underline !leading-percent-100 leading-percent-100" data-text="' +
                            recipe.title +
                            '" href="' +
                            recipe.permalink +
                            '">' +
                            recipe.title.slice(0, 40) +
                            "...</a></h2>" +
                            '<p class="mt-0 text-center text-grey font-body text-xlg lg:block hidden">' +
                            recipe.excerpt.slice(0, 300) +
                            "...</p>" +
                            "</div>" +
                            "</div>" +
                            "</div>" +
                            "</div>");
                    }
                    document.getElementById("container-posts").innerHTML = html.join("\n");
                    this.$dispatch("loader:close");
                });
            });
        },
    };
});
alpinejs_1.default.data("archive_blog_posts", () => {
    return {
        data: {
            page: 1,
            limit: 24,
            totalPages: 0,
            pagination: true,
        },
        populate() {
            this.$dispatch("loader:open");
            const formData = new FormData();
            formData.append("action", "archive_posts");
            formData.append("page", this.data.page);
            formData.append("limit", this.data.limit);
            fetch("/wp-admin/admin-ajax.php", {
                method: "POST",
                credentials: "same-origin",
                body: formData,
            }).then((res) => {
                res.json().then((data) => {
                    console.log(formData);
                    this.data.totalPages = data.total_pages;
                    console.log(this.data.totalPages);
                    console.log(this.data.page);
                    console.log(this.data.limit);
                    console.log(data);
                    const html = [];
                    for (const recipe of data.posts) {
                        html.push("" +
                            '<div class="ricette bg-beige box-shadow flex lg:block">' +
                            '<a href="' +
                            recipe.permalink +
                            '">' +
                            '<figure class="lg:w-full w-[120px] lg:h-[266px] m-0">' +
                            '<img class="lg:w-full w-[120px] lg:h-[266px] h-[120px] object-cover object-center" src="' +
                            recipe.thumbnail +
                            '">' +
                            "</figure>" +
                            "</a>" +
                            '<div class="lg:min-h-[195px] lg:pt-[35px] lg:pb-[40px] lg:px-[20px] p-[16px]">' +
                            '<h2 class="mt-0 lg:mb-[20px] mt-0 lg:text-center text-left !leading-percent-100"><a class="ricetta_titolo text-blue lg:!text-xl xm:text-xsm text-xxs font-black lg:tracking-[4px] tracking-[3px] font-title no-underline !leading-percent-100" data-text="' +
                            recipe.title +
                            '" href="' +
                            recipe.permalink +
                            '">' +
                            recipe.title.slice(0, 40) +
                            "...</a></h2>" +
                            '<p class="mt-0 text-center text-grey font-body text-xlg lg:block hidden">' +
                            recipe.excerpt.slice(0, 300) +
                            "...</p>" +
                            "</div>" +
                            "</div>" +
                            "</div>" +
                            "</div>");
                    }
                    document.getElementById("container-posts").innerHTML = html.join("\n");
                    this.$dispatch("loader:close");
                });
            });
        },
    };
});
window.Alpine = alpinejs_1.default;
alpinejs_1.default.start();
/*
function handleSlideChange(currentSlide: number) {
  const slideItems = document.querySelectorAll('.swiper-slide');
  if (currentSlide < slideItems.length) {
    const videos = slideItems[currentSlide].querySelectorAll('.video');
    slideItems.forEach((slideItem, index) => {
      if (index !== currentSlide) {
        const slideVideos = slideItem.querySelectorAll('video');
        slideVideos.forEach((video: HTMLVideoElement) => {
          video.pause();
        });
      } else {
        const slideVideos = slideItem.querySelectorAll('video');
        slideVideos.forEach((video: HTMLVideoElement) => {
          video.play();
        });
      }
    });
  }
}*/
// Avvia il primo video automaticamente
/*const firstVideo = document.querySelector(
  ".slide-item.active video"
) as HTMLVideoElement;
if (firstVideo) {
  firstVideo.play();
}*/
const scopriRicetteButton = document.getElementById("scopri_ricette");
if (scopriRicetteButton) {
    scopriRicetteButton === null || scopriRicetteButton === void 0 ? void 0 : scopriRicetteButton.addEventListener("click", () => {
        const ricetteElements = document.querySelectorAll(".ricette");
        ricetteElements.forEach((ricetta) => {
            ricetta.classList.remove("hidden");
            ricetta.classList.add("flex", "lg:block");
        });
        scopriRicetteButton.classList.add("!hidden");
    });
}
function isMobileDevice() {
    return window.innerWidth <= 768;
}
function isMobileSmallDevice() {
    return window.innerWidth <= 660;
}
function truncateText(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
}
function handleBreadcrumbTextTruncation() {
    const breadcrumbActiveElement = document.querySelector(".breadcrumb .active");
    if (breadcrumbActiveElement && isMobileDevice()) {
        const text = breadcrumbActiveElement.textContent || "";
        const truncatedText = truncateText(text, 20);
        if (breadcrumbActiveElement) {
            breadcrumbActiveElement.textContent = truncatedText;
        }
    }
    else {
        if (breadcrumbActiveElement) {
            const dataText = breadcrumbActiveElement.getAttribute("data-text");
            if (dataText) {
                breadcrumbActiveElement.textContent = dataText;
            }
        }
    }
}
function handleRicetteTextTruncation() {
    console.log("handleRicetteTextTruncation");
    const recipeElements = document.querySelectorAll(".ricetta_titolo");
    if (recipeElements.length > 0) {
        recipeElements.forEach((recipeElement) => {
            const dataText = recipeElement.getAttribute("data-text");
            if (isMobileSmallDevice()) {
                recipeElement.textContent = dataText;
                const text = recipeElement.textContent || "";
                const truncatedText = truncateText(text, 36);
                recipeElement.textContent = truncatedText;
            }
            else {
                if (dataText) {
                    recipeElement.textContent = dataText;
                }
            }
        });
    }
}
window.addEventListener("load", () => {
    for (const el of Array.from(document.querySelectorAll("select[data-selected]")))
        el.value = el.getAttribute("data-selected");
    if (document.querySelector(".home-carousel"))
        new swiper_1.default(".home-carousel", {
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
            },
            /*on: {
            slideChange: () => {
              handleSlideChange(homeSwiper.activeIndex);
            },
          },*/
        });
    if (document.querySelector(".eventi-carousel"))
        new swiper_1.default(".eventi-carousel", {
            loop: true,
            slidesPerView: 1.1,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                },
            },
            pagination: {
                el: ".swiper-pagination",
            },
        });
    if (document.querySelector(".prod-carousel"))
        new swiper_1.default(".prod-carousel", {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    if (document.querySelector(".chi-siamo-carousel"))
        new swiper_1.default(".chi-siamo-carousel", {
            slidesPerView: 1.2,
            spaceBetween: 15,
            loop: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                },
            },
        });
    if (document.querySelector(".sostenibilita-goal-carousel"))
        new swiper_1.default(".sostenibilita-goal-carousel", {
            slidesPerView: 1.2,
            spaceBetween: 12,
            loop: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1300: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },
        });
    if (document.querySelector(".related-carousel"))
        new swiper_1.default(".related-carousel", {
            slidesPerView: 2.5,
            spaceBetween: 15,
            loop: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
        });
    if (document.querySelector(".sostenibilita-carousel"))
        new swiper_1.default(".sostenibilita-carousel", {
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1.5,
                    spaceBetween: 15,
                },
                1300: {
                    slidesPerView: 2.5,
                    spaceBetween: 15,
                },
            },
        });
    handleBreadcrumbTextTruncation();
    window.addEventListener("resize", handleBreadcrumbTextTruncation);
    window.addEventListener("resize", handleRicetteTextTruncation);
    const images = document.querySelectorAll("img:not([width]):not([height])");
    if (images.length > 0) {
        images.forEach((img) => {
            const { width, height } = img.getBoundingClientRect();
            if (width > 0 && height > 0) {
                img.setAttribute("width", width.toString());
                img.setAttribute("height", height.toString());
            }
        });
    }
    const autoPlayVideos = document.querySelectorAll("video[data-custom-autoplay");
    if (autoPlayVideos.length > 0) {
        autoPlayVideos.forEach((video) => {
            if (video.offsetParent) {
                console.log("play!", video);
                video.play();
            }
        });
    }
});
function isAppleDevice() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function applyDeviceStyles() {
    const body = document.querySelector('body');
    if ((isAppleDevice() && isSafari()) || isSafari()) {
        body === null || body === void 0 ? void 0 : body.classList.add('apple-mobile');
    }
    else {
        body === null || body === void 0 ? void 0 : body.classList.add('other-device');
    }
}
applyDeviceStyles();
